module.exports = __webpack_public_path__ + "img/DateRange.09caa152.svg";